import React, { useState } from "react";
import { useStore } from "stores/connect";
import PaginatedEntityTable from "components/common/PaginatedEntityTable";
import QueryHelper from "components/common/QueryHelper";
import useUserLayoutPreferences from "components/common/EntityDataTable/hooks/useUserLayoutPreferences";
import { ATTRIBUTE_STATUS } from "components/common/EntityDataTable/Constants";
import getForwarderInputsTableElements from "./Constants";
import forwarderInputColumnRenderers from "./ColumnRenderers";
import { fetchForwarderInputsList, keyFn } from "./usePaginatedForwarderInputs";
import FilterValueRenderers from "./FilterValueRenderers";
import ForwarderInputsRowActions from "./ForwarderInputsActions";
import useTableElements from "./useTableElements";
import { ForwarderInputMetricsProvider } from "./ForwarderInputMetricsContext";
import { backendFieldsForVisibleColumns } from "./metricColumns";
import { compositeIdFor } from "../hooks/useForwarderInputMetrics";
import ForwarderInputTypesStore from "../stores/ForwarderInputTypesStore";
const ForwarderInputsOverview = () => {
  var _a;
  const { forwarderInputTypes: inputTypes } = useStore(ForwarderInputTypesStore);
  const { tableLayout, additionalAttributes } = getForwarderInputsTableElements();
  const { expandedSections } = useTableElements();
  const columnRenderers = forwarderInputColumnRenderers({ inputTypes: inputTypes || {} });
  const entityActions = (input) => /* @__PURE__ */ React.createElement(ForwarderInputsRowActions, { input });
  const [visiblePairs, setVisiblePairs] = useState([]);
  const onDataLoaded = (data) => {
    const nextPairs = data.list.filter((entity) => !!entity.forwarder_node_id).map((entity) => ({ input_id: entity.input_id, forwarder_node_id: entity.forwarder_node_id }));
    setVisiblePairs((current) => {
      const sameLength = current.length === nextPairs.length;
      const sameOrder = sameLength && current.every((pair, i) => compositeIdFor(pair) === compositeIdFor(nextPairs[i]));
      return sameOrder ? current : nextPairs;
    });
  };
  const { data: layoutPreferences } = useUserLayoutPreferences(tableLayout.entityTableId);
  const userPrefs = (_a = layoutPreferences == null ? void 0 : layoutPreferences.attributes) != null ? _a : {};
  const userSelection = Object.entries(userPrefs).filter(([, pref]) => pref.status === ATTRIBUTE_STATUS.show).map(([attributeId]) => attributeId);
  const visibleColumns = userSelection.length > 0 ? userSelection : tableLayout.defaultDisplayedAttributes;
  const requestedFields = backendFieldsForVisibleColumns(visibleColumns);
  return /* @__PURE__ */ React.createElement(ForwarderInputMetricsProvider, { pairs: visiblePairs, fields: requestedFields }, /* @__PURE__ */ React.createElement(
    PaginatedEntityTable,
    {
      humanName: "forwarder inputs",
      additionalAttributes,
      queryHelpComponent: /* @__PURE__ */ React.createElement(QueryHelper, { entityName: "forwarder input" }),
      entityActions,
      tableLayout,
      fetchEntities: fetchForwarderInputsList,
      onDataLoaded,
      keyFn,
      entityAttributesAreCamelCase: false,
      columnRenderers,
      filterValueRenderers: FilterValueRenderers,
      expandedSectionRenderers: expandedSections
    }
  ));
};
export default ForwarderInputsOverview;
